import React, { useEffect } from 'react'


function useTitle(title){
    useEffect(() => {
        const suffix = 'Fast Fleet'
        document.title = title ? `${title} | ${suffix}` : suffix;
    }, [title])
}


export default useTitle;